import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as customerActions from '../Actions/customerActions';
import * as languageActions from '../Actions/languageActions';
import CurriculumList from "../Components/User/CurriculumList";
import ProductFilter from "../Components/User/ProductFilter";
import { curriculumService } from "../Services/CurriculumService.js";
import { userService } from "../Services/UserService.js";
import {searchFilterService} from "../Services/SearchFilterService.js";
import {languageService} from "../Services/LanguageService.js";
import { normalize } from 'normalizr';
import {  orderSchema, userSchema, customerSchema, customerListSchema } from '../Schemas/OrderSchema.js';

class CurriculumListContainer extends Component {
	constructor(props) {
		super(props);
		this.state={
			curriculums: [],
			products: [],
			ratings: [],
			productFilter: {taskFilter: "",
							srcLangFilter: "",
							trgLangFilter: ""
							},
			orderFilter: 'ALF',
		};
		this.setProductFilter = this.setProductFilter.bind(this);
		this.setOrderUsers = this.setOrderUsers.bind(this);
		this.orderingALF = this.orderingALF.bind(this);
		this.orderingRNK = this.orderingRNK.bind(this);
		this.orderingAVA = this.orderingAVA.bind(this);
		this.setRankingsToUsers = this.setRankingsToUsers.bind(this);
	}
	
	componentDidMount() {
		curriculumService.getCurriculums()
			.then( response => {this.setState({curriculums: response.data.sort(this.orderingALF)}); return 1;})
			.then( r => {return curriculumService.getTranslatorProducts();})
			.then( response => {this.setState({products: response.data}); return 1;})
			.then( r => {return userService.getAllRatings();})
			.then( response => {this.setState({ratings: this.setRankingsToUsers(response.data)}); return 1;})
			.catch(err => {/*console.log(err);*/});
	}
	
	setRankingsToUsers(ratings){
		let rating = new Object();
		ratings.forEach( r => { if(r.style>0 && r.grammarortog>0 && r.localization>0){
									if(!rating.hasOwnProperty(r.user.id)){
										rating[r.user.id] = new Object();
										let lastTerm = new Object();
										lastTerm.year=r.year;
										lastTerm.quarter=r.quarter;
										rating[r.user.id].lastTerm=lastTerm;
										rating[r.user.id].rating=new Array();
									}
									let curren_rating = (r.style+r.grammarortog+r.localization)/3;
									rating[r.user.id].rating.push(curren_rating);
									
									if((r.year>rating[r.user.id].lastTerm.year) ||
										((r.year===rating[r.user.id].lastTerm.year) && (r.quarter>=rating[r.user.id].lastTerm.quarter)) ){
											rating[r.user.id].lastTerm.year=r.year;
											rating[r.user.id].lastTerm.quarter=r.quarter;
									}
								}
							}
		);
		return rating;
	}
	
	setProductFilter(filter){
		this.setState({productFilter: filter})
	}
	
	setOrderUsers(orderType){
		let orderedCurriculums = this.state.curriculums;
		switch (orderType) {
			case 'ALF': orderedCurriculums.sort(this.orderingALF);	break;
			case 'RNK': orderedCurriculums.sort(this.orderingRNK);	break;
			case 'AVA': orderedCurriculums.sort(this.orderingAVA);	break;
		}
		//console.log(orderedCurriculums);
		//console.log(orderedCurriculums[0]);
		//console.log(orderedCurriculums[1]);
		//console.log(orderedCurriculums[2]);
		this.setState({	orderFilter: orderType,
						curriculums: orderedCurriculums})
		
	}
	
	orderingALF(a, b){
		if(typeof a.user == "undefined"){
			if(typeof b.user == "undefined"){
				return 0;
			}else{
				return 1;
			}
		}else{
			if(typeof b.user == "undefined"){
				return -1;
			}
		}
		return a.user.username.localeCompare(b.user.username);
	}
	
	orderingRNK(a, b){
		if(typeof a.user == "undefined"){
			if(typeof b.user == "undefined"){
				return 0;
			}else{
				return 1;
			}
		}else{
			if(typeof b.user == "undefined"){
				return -1;
			}
		}
		
		if(typeof this.state.ratings[a.user.id] == "undefined"){
			if(typeof this.state.ratings[b.user.id] == "undefined"){
				return 0;
			}else{
				return 1;
			}
		}else{
			if(typeof this.state.ratings[b.user.id] == "undefined"){
				return -1;
			}
		}
		
		if((typeof this.state.ratings[a.user.id]!== "undefined") && (typeof this.state.ratings[b.user.id]!== "undefined")){
			let aR = this.state.ratings[a.user.id].rating.reduce((x, z) => x + z, 0);
			aR = (aR/this.state.ratings[a.user.id].rating.length) || 0;
			let bR = this.state.ratings[b.user.id].rating.reduce((x, z) => x + z, 0);
			bR = (bR/this.state.ratings[b.user.id].rating.length) || 0;
			//console.log(aR+" | "+bR);
			return (aR < bR ? 1 : (aR > bR ? -1 : 0));
		}
	}
	
	orderingAVA(a, b){
		if(typeof a.user == "undefined"){
			if(typeof b.user == "undefined"){
				return 0;
			}else{
				return 1;
			}
		}else{
			if(typeof b.user == "undefined"){
				return -1;
			}
		}
		if(typeof this.state.ratings[a.user.id] == "undefined"){
			if(typeof this.state.ratings[b.user.id] == "undefined"){
				return 0;
			}else{
				return 1;
			}
		}else{
			if(typeof this.state.ratings[b.user.id] == "undefined"){
				return -1;
			}
		}
		if((typeof this.state.ratings[a.user.id]!== "undefined") && (typeof this.state.ratings[b.user.id]!== "undefined")){
			if(this.state.ratings[a.user.id].lastTerm.year > this.state.ratings[b.user.id].lastTerm.year){
				return -1;
			}else if(this.state.ratings[a.user.id].lastTerm.year < this.state.ratings[b.user.id].lastTerm.year){
				return 1;
			}else{
				if(this.state.ratings[a.user.id].lastTerm.quarter > this.state.ratings[b.user.id].lastTerm.quarter){
					return -1;
				}else if(this.state.ratings[a.user.id].lastTerm.quarter < this.state.ratings[b.user.id].lastTerm.quarter){
					return 1;
				}else{
					return 0;
				}
			}
		}
	}
	
	render() {
		// let curriculums = (this.props.search.length > 0) ? (searchFilterService.objectFilter(this.props.customerRecords, searchFilterService.customerFilter)) : (this.props.customerRecords);
		let cvList = [];
	    if(	this.state.curriculums && this.state.curriculums.length>0 &&
			this.state.products && this.state.products.length>0){
			
			for(let j=0; j<this.state.curriculums.length; j++){
				if(typeof (this.state.curriculums[j].user) !== "undefined"){
						const products = this.state.products.find(p => p.userId===this.state.curriculums[j].user.id);
						//console.log(products);
						if(typeof (products) !== "undefined"){
							// General Search
							if(	(!this.props.search || this.props.search.length===0) ||
								(this.state.curriculums[j].user.username.toLowerCase().includes(this.props.search.toLowerCase())) ||
								((this.state.curriculums[j].user.firstName+" "+this.state.curriculums[j].user.lastName).toLowerCase().includes(this.props.search.toLowerCase()))
								//|| (products.tasks.reduce( (a,v)=> a || v.languageCodes.reduce( (a2,v2) => a2 || v2.toLowerCase().includes(this.props.search.toLowerCase()), a), false ))
								){
									// Filter
									if( (this.state.productFilter.taskFilter==""	|| (products.tasks.reduce( (a,v)=> a || v.taskName===this.state.productFilter.taskFilter, false ))) &&
										(this.state.productFilter.srcLangFilter==""	|| (products.tasks.reduce( (a,v)=> a || v.languageCodes.reduce( (a2,v2) => a2 || v2.split("-")[0].toLowerCase().includes(this.state.productFilter.srcLangFilter.toLowerCase()), a), false ))) &&
										(this.state.productFilter.trgLangFilter==""	|| (products.tasks.reduce( (a,v)=> a || v.languageCodes.reduce( (a2,v2) => a2 || (v2.split("-").length>1 && v2.split("-")[1].toLowerCase().includes(this.state.productFilter.trgLangFilter.toLowerCase())), a), false )))
										){
										cvList.push({curriculum: this.state.curriculums[j], products: products, rating: this.state.ratings[this.state.curriculums[j].user.id]});
									}
							}
						}
					}
			}

			return <div className="d-grid gap-3">
						<div>
							<ProductFilter	setProductFilter={this.setProductFilter}
											productFilter={this.state.productFilter}
											setOrderFilter={this.setOrderUsers}
											orderFilter={this.state.orderFilter}/>
						</div>
						<div>
							<CurriculumList curriculums ={cvList}/>
						</div>
					</div>
		}else{
			return <div className="d-grid gap-3">
						<div>
							<ProductFilter	setProductFilter={this.setProductFilter}
											productFilter={this.state.productFilter}
											setOrderFilter={this.setOrderUsers}
											orderFilter={this.state.orderFilter}/>
						</div>
						<div>Loading...</div>
					</div>
		}
	}
}

function mapStateToProps(state, ownProps) {  
//	console.log('mapStateToProps [CustomerListContainer]: ' + JSON.stringify(state));
	return {langPairs: state.languagePairs, user: state.user, search: state.search.searchString}
}

function mapDispatchToProps(dispatch) {  
//	return {actions: bindActionCreators(customerActions, dispatch)}
	return {actions: bindActionCreators(Object.assign({}, customerActions, languageActions), dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(CurriculumListContainer);  